import { Col, DatePicker, Form, Input, Radio, Row, Select, theme, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { isMobile } from '../../../../../util/device-helper';

const ApplicantComponent = () => {

    const { useToken } = theme;
    const { token } = useToken();

    return (
        <>
            <h3 style={{ borderBottom: "2px solid #D9D9D9", paddingBottom: '8px', marginBottom: '12px' }}>Applicant</h3>
            <Row style={{ marginBottom: '10px' }}>
                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Customer Name</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="name"
                        label=""
                        rules={[{ required: true, message: 'Please Enter Customer Name' }]}
                    >
                        <Input
                            type="text"
                            placeholder="Type name"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px'
                    }}>Mobile Number</Typography.Title>
                    <Form.Item
                        name="phone"
                        style={{
                            margin: 0
                        }}
                        rules={[{ required: false }]}

                    >
                        <Input
                            type="text"
                            readOnly={true}
                            placeholder="9987654321"
                            style={{
                                width: '99%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                            className='prefix-select-input'

                            addonBefore={<Select
                                showSearch={true}
                                value="+91"
                                className="lead-custom-select"
                                style={{
                                    width: 70,
                                    borderRadius: token.borderRadius,
                                    boxShadow: 'none',
                                    height: '100%'
                                }}
                                options={[
                                    { value: '+91', label: '+91' }
                                ]}

                            />}
                        />
                    </Form.Item>
                </Col>
                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Email address</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="email"
                        label=""
                        rules={[{ required: true, message: 'Please Enter Customer Name' }]}
                    >
                        <Input
                            type="text"
                            placeholder="janedoe890@ymail.com"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px'
                    }}>Date of Birth</Typography.Title>
                    <Form.Item
                        name="birthDate"
                        style={{
                            margin: 0
                        }}
                        rules={[{ required: false }]}
                        initialValue={dayjs(dayjs())}
                    >
                        <DatePicker
                            inputReadOnly={isMobile()}
                            style={{
                                border: '1px solid #92B5D7',
                                width: '70%',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                            placeholder="Select date" />

                    </Form.Item>
                </Col>
                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>PAN No.</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="pan"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="ex. BZPQ22025K"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Aadhaar No.</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="adhaar"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="321456321548"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Occupation</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="occupation"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Type occupation"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Company Name</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="status"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Type company name"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Address Line 1</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="address1"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Type building no, floor no"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Address Line 2</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="address2"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Landmark, post office, pincode"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>


                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Street</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="street"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Type street no."
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Pincode</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="pincode"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="ex. 700010"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>State</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="state"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Type state name"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>City</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="city"
                        label=""
                    >
                        <Input
                            type="text"
                            placeholder="Type city name"
                            style={{
                                width: '100%',
                                border: '1px solid #92B5D7',
                                borderRadius: token.borderRadius,
                                boxShadow: 'none',
                                height: '40px'
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24} style={{ paddingRight: '20px', marginBottom: '20px' }}>
                    <Typography.Title level={5} style={{
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Nationality</Typography.Title>
                    <Form.Item
                        style={{
                            margin: 0
                        }}
                        name="nationality"
                        label=""
                        initialValue={"indian"}

                    >
                        <Radio.Group className='lead-nationality-radio'>
                            <Radio.Button value="indian"
                                style={{ marginRight: '6px', border: '1px solid #92B5D7', borderRadius: token.borderRadius, background: '#E0EEF7', color: '#6D6C68' }}
                            >
                                Indian
                            </Radio.Button>
                            <Radio.Button value="NRI"
                                style={{ marginRight: '6px', border: '1px solid #92B5D7', borderRadius: token.borderRadius, background: '#E0EEF7', color: '#6D6C68' }}
                            >
                                NRI
                            </Radio.Button>
                        </Radio.Group>


                    </Form.Item>
                </Col>



            </Row>
        </>
    )
}

export default ApplicantComponent